import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { id: "events" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_bar = _resolveComponent("header-bar")!
  const _component_home_event = _resolveComponent("home-event")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_bar),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Upcoming events", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
        return (_openBlock(), _createBlock(_component_home_event, {
          key: event.id,
          title: event.title,
          startDate: event.startTime,
          endDate: event.endTime,
          description: event.description,
          location: event.location,
          id: event.id
        }, null, 8, ["title", "startDate", "endDate", "description", "location", "id"]))
      }), 128)),
      (_ctx.events.length === 0)
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("i", null, "No upcoming events.", -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}